import { Switch as AntdSwitch } from "antd";
import "./style.scss";

function Switch({
  label,
  isChecked,
  onChange,
  className,
  labelClassName,
  inputClassName,
  size,
  id,
}) {
  return (
    <div className={`switch-container ${className}`}>
      <AntdSwitch
        className={`switch-input ${inputClassName}`}
        size={size}
        checked={isChecked}
        onChange={onChange}
        id={id}
      />
      <label htmlFor={id} className={`switch-label ${labelClassName}`}>
        {label}
      </label>
    </div>
  );
}

export default Switch;
